import { NavLink, Outlet } from 'react-router-dom';
import { cn } from '@techsofit/ui';

const TABS = [
  { to: '/workouts', label: 'Workouts', end: true },
  { to: '/workouts/library', label: 'Library' },
  { to: '/workouts/groups', label: 'Groups' },
  { to: '/workouts/schedule', label: 'Schedule' },
  { to: '/workouts/compliance', label: 'Compliance' },
];

/** Shared tab bar for the Workouts section. */
export function WorkoutsLayout() {
  return (
    <div className="animate-fade-up">
      <nav className="mb-5 flex gap-1 overflow-x-auto border-b border-line">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              cn(
                '-mb-px shrink-0 border-b-2 px-3.5 py-2.5 text-sm font-medium transition-colors',
                isActive ? 'border-ink text-ink' : 'border-transparent text-muted hover:text-ink',
              )
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
